/**
 * What the operator is told when a disbursement send ends without the deal being funded.
 *
 * `status` is the body of `GET /applications/{id}/disbursement-status`. Three outcomes read
 * differently and only the last may be sent again; the server refuses a second send for the
 * other two, so telling the operator to click Disburse Now would send them into a 409:
 *
 *  - `send_unknown`: the create request may have reached GoCardless and its outcome is not
 *    known (with or without a payment id);
 *  - `failed` with a payment id: the payment exists at GoCardless (a Confirmation of Payee
 *    refusal, or a connect error on the verify poll or approve call after the create),
 *    created and not confirmed as sent;
 *  - `failed` with no payment id: nothing was created and a retry is safe.
 *
 * Neither locked outcome points at `recover-disbursement`: it has no screen, so the copy
 * sends the operator to an engineer, who records the payment or releases the lock.
 */
export function disbursementFailureMessage(status) {
  const error = status?.gc_send_error;
  const paymentId = status?.gc_payment_id;
  if (status?.gc_send_status === "send_unknown") {
    return (
      `The disbursement outcome is unknown: ${error || "no error returned"}. ` +
      `Do NOT send again. Check GoCardless${paymentId ? ` for payment ${paymentId}` : ""} ` +
      "and contact an engineer: the deal is locked against a second send until they resolve it."
    );
  }
  if (paymentId) {
    return (
      `The disbursement was not completed: ${error || "unknown error"}. ` +
      `GoCardless payment ${paymentId} EXISTS (created, not confirmed as sent). ` +
      "Check it in GoCardless and do NOT send again. Contact an engineer: the deal is " +
      "locked against a second send until they resolve it."
    );
  }
  return (
    `GoCardless rejected the disbursement: ${error || "unknown error"}. ` +
    "No payment was created. Fix the issue in GoCardless and click Disburse Now again."
  );
}
